/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const RefinePane = () => ({
   replace: true,
   controller: 'RefinePaneCtrl',
   templateUrl: '/assets/refine/refinePane.html'
})

const QuickFilters = () => ({
   replace: true,
   controller: 'QuickFiltersCtrl',
   templateUrl: '/assets/refine/quickFilters.html'
})

// @ts-expect-error TS(7006) FIXME: Parameter 'results' implicitly has an 'any' type.
const FacetFields = (results, $timeout, $window) => ({
   replace: true,
   controller: 'FacetsCtrl',
   templateUrl: '/assets/refine/facets.html',

   link(scope: any) {
      // retain focus on selected facet upon return of results
      const newResults = () => $timeout(function() {
         if (scope.triggerId) {
            let focusEl
            if (focusEl = document.getElementById(scope.triggerId)) { focusEl.focus() }
            return scope.triggerId = null
         }
      })
      results.on('new', newResults)
      return scope.$on('$destroy', () => {
         return results.off('new', newResults)
      })
   }
})

const FacetField = ($timeout: any) => ({
   replace: true,
   templateUrl: '/assets/refine/facetField.html',

   link(scope: any, element: any, attrs: any) {
      //TODO WH why is the timeout needed? should this maybe be done after digest or something? don't really understand
      return $timeout(function() {
         const facetList = angular.element(element)
         if (!scope.facet.showmore) {
            return 
         }
      
         const goingToObserve = facetList.find('.moreFacetsLink')[0]
         if (!goingToObserve) {
            return
         }

         const observerOptions = 
        {root: facetList[0]}

         const callback = (changes: any) => changes.forEach(function(change: any) {
            if (change.isIntersecting) {
               scope.moreFacetValues(scope.facet)
               return observer.unobserve(goingToObserve)
            }
         })
    
         var observer = new IntersectionObserver(callback, observerOptions)
         return observer.observe(goingToObserve)
      })
   }
})

const FacetName = () => ({
   replace: true,
   templateUrl: '/assets/refine/facetName.html',
   controllerAs: 'fn',
   controller: FacetNameController,

   bindToController: {
      facet: '<',
      count: '<',
      index: '<',
      moreFacetsFilter: '<',
      source: '<'
   }
})

const FacetExclude = () => ({
   replace: true,
   templateUrl: '/assets/refine/facetExclude.html',
   controllerAs: 'fe',
   controller: FacetExcludeController,

   bindToController: {
      facet: '<',
      index: '<',
      isSelected: '<'
   }
})


const DateSlider = () => ({
   replace: true,
   controller: 'PubDateSliderCtrl',
   templateUrl: '/assets/refine/dateSlider.html'
})

const DatePresetLink = () => ({
   replace: true,
   templateUrl: '/assets/refine/datePresetLink.html',
   controllerAs: 'dpl',
   controller: DatePresetLinkController,

   bindToController: {
      displayText: '<',    
      isSelected: '<'
   }
})

class FacetNameController {
   $scope: any
   constructor($scope: any) {
      this.$scope = $scope
   }
}

class FacetExcludeController {
   $scope: any
   constructor($scope: any) {
      this.$scope = $scope
   }
}

class DatePresetLinkController {
   $scope: any
   constructor($scope: any) {
      this.$scope = $scope  
   }
}

FacetNameController.$inject = ['$scope'] 
FacetExcludeController.$inject = ['$scope'] 
DatePresetLinkController.$inject = ['$scope']

angular.module('summonApp.directives')
   .directive('refinements', RefinePane)
   .directive('quickFilters', QuickFilters)
   .directive('facetFields', ['dataService', '$timeout', '$window', FacetFields])
   .directive('facetField', ['$timeout', FacetField])
   .directive('dateSlider', DateSlider)
   .directive('facetName', FacetName)
   .directive('facetExclude', FacetExclude)
   .directive('datePresetLink', DatePresetLink)
